import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

const baseTitleStyle = css({
  padding: 8,
  fontWeight: 700,
});

const titleStyle = (theme: Theme) => css(baseTitleStyle, {
  fontSize: 16,
  textTransform: 'uppercase',
  border: `0 solid ${theme.reportColors.borderPrimary}`,
  borderWidth: '0 1px',
  'tr:first-of-type &': {
    borderTopWidth: 1,
    borderRadius: '8px 8px 0 0',
  },
});

const rowStyle = ({ isInteractive }: { isInteractive?: boolean } = {}) => (theme: Theme) => css({
  breakInside: 'avoid',
  color: theme.reportColors.textPrimary,
  cursor: isInteractive ? 'pointer' : undefined,

  'tbody &:nth-of-type(2n)': {
    background: theme.reportColors.tableRowBackgroundPrimary,
  },
  'tbody &:nth-of-type(2n + 1)': {
    background: theme.reportColors.tableRowBackgroundSecondary,
  },
});

type ExportReportTableTitleRowProps = Readonly<{
  title: string;
  style?: 'sub';
  className?: string;
  isInteractive?: boolean;
  onClick?: () => void;
}>;

export const ExportReportTableTitleRowComponent = (props: ExportReportTableTitleRowProps) => {
  return (
    <tr
      css={rowStyle({ isInteractive: props.isInteractive })}
      className={props.className}
      onClick={props.onClick}
    >
      <td colSpan={999} css={props.style === 'sub' ? baseTitleStyle : titleStyle}>{props.title}</td>
    </tr>
  );
};
